export default __webpack_public_path__ + "static/media/sync.ad311527.png";